/* eslint-disable import/prefer-default-export */

import hamletClient from 'modules/hamlet';
import { StoredPromotion } from './model';

export const getPromotion = async (promoCode: string): Promise<StoredPromotion | null> => {
  const r = await hamletClient.get(`/1.0/public/promotion/code/${promoCode}`);
  return r.data;
};
